import { render, staticRenderFns } from "./KtbFastPayFail.vue?vue&type=template&id=39b9cdd0&scoped=true"
import script from "./KtbFastPayFail.vue?vue&type=script&lang=js"
export * from "./KtbFastPayFail.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPayFail.vue?vue&type=style&index=0&id=39b9cdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9cdd0",
  null
  
)

export default component.exports